// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* purgecss start ignore */\n\n*:focus {\n  outline: 0 !important;\n}\n\nbody,html {\n  overflow: hidden;\n  height: 100%;\n}\n\nbody {\n  background-color: rgb(42, 58, 75);\n}\n\n/* purgecss end ignore */\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
